import { Settings } from '@mui/icons-material'
import styled from 'styled-components'
import { UserGroupDto } from '../../../models/Dto/UserGroupDto'
import { Mentee, User } from '../../../models/User'
import { MaxHeightProps } from '../../Layout/CommonStyle'

type Props = {
  students: User[]
  selectedStudent: User | null
  setSelectedStudent: (student: User | null) => void
  //
  menteeGroups: UserGroupDto[]
  mentees: Mentee[]
  selectedGroup: number
  selectGroup: (index: number) => void
  selectedUser: number
  selectUser: (index: number) => void
  userListHeight: string
}

function LeftSide(props: Props) {
  return (
    <Container>
      {/* <List>
        <TitleItem>그룹</TitleItem>
        <ListUl>
          {props.menteeGroups &&
            props.menteeGroups.map((menteeGroup, index) => (
              <Item
                key={index}
                value={props.selectedGroup === index ? 'selected' : ''}
                onClick={() => props.selectGroup(index)}
              >
                {menteeGroup.userGroup.name}
              </Item>
            ))}
        </ListUl>
      </List>
      <List>
        <TitleItem>멘티</TitleItem>
        <ListUl maxHeight={props.userListHeight}>
          {props.mentees &&
            props.mentees.map((mentee, index) => (
              <Item
                key={index}
                value={props.selectedUser === index ? 'selected' : ''}
                onClick={() => props.selectUser(index)}
              >
                {mentee.checked ? 'v' : ''} {mentee.mentee.username}
              </Item>
            ))}
        </ListUl>
      </List> */}
      <List>
        <TitleItem>학생</TitleItem>
        <ListUl maxHeight={props.userListHeight}>
          {props.students &&
            props.students.map((student, index) => (
              <Item
                key={index}
                value={props.selectedStudent === student ? 'selected' : ''}
                onClick={() => props.setSelectedStudent(student)}
              >
                {student.checked ? 'v' : ''} {student.username}
              </Item>
            ))}
        </ListUl>
      </List>
    </Container>
  )
}

const Container = styled.div`
  grid-area: leftside;
  display: flex;
`

const ListUl = styled.ul`
  max-height: ${(props: MaxHeightProps) =>
    props.maxHeight === null ? '600px' : props.maxHeight};
  //max-height: 600px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
  }
  &::-webkit-scrollbar-track {
    background-color: white;
  }
`

const List = styled.div`
  padding: 5px;
`
const TitleItem = styled.div`
  border-top: 1px solid #ddd;
  background-color: #3391e2;
  color: white;
  text-align: center;
  padding: 10px 40px;
  margin-bottom: 5px;
`

const Item = styled.li`
  list-style: none;
  padding: 10px 40px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;

  background-color: ${(props) =>
    props.value && props.value === 'selected' ? '#ffbc2c' : 'white'};

  &:hover {
    background-color: ${(props) =>
      props.value && props.value === 'selected' ? '#ffbc2c' : 'aliceblue'};
  }

  /* &:first-child {
    border-top: 1px solid #ddd;
    background-color: #3391e2;
    color: white;
    text-align: center;
  } */
`

export default LeftSide
